<div id="progress-navigation">
  <div class="container" [(ngModel)]="currentProgress.id" ngDefaultControl>
    <ng-template ngFor
                 let-_progress [ngForOf]="getProgressList()"
                 let-i = "index"
                 let-last = "last"
                 [ngForTrackBy]="trackById">
      <span class="step"
          [ngClass]="_progress.id === currentProgress.id ? 'current' : ''">
        <span class="step_content">
          <span class="number">{{ i + 1 }}</span>
          <span class="description">. {{ _progress.title }}</span>
        </span>
      </span>
    </ng-template>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/progress/progress-navigation/progress-navigation.component.html